import React, { useCallback, useEffect, useMemo, useState } from "react";
import CardLayout from "react-lib/apps/common/CardLayout";
import CardSelectDoctorOrderNoteUX from "./CardSelectDoctorOrderNoteUX";
import { useIntl } from "react-intl";
import moment from "moment";
import { formatDateToStringBe } from "react-lib/utils/dateUtils";
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import { Checkbox, Form, FormField, FormGroup } from "semantic-ui-react";

const CARD_SELECT_DOCTOR_ORDER_NOTE = "CardSelectDoctorOrderNote";

type CardSelectDoctorOrderNoteProps = {
  onEvent: (e: any) => any;
  setProp: (key: string, value: any, callback?: () => any) => any;
  divisionType?: string;
  django?: any;

  onClose?: any;
  nurseNoteSelectDoctorOrderNote?: any;
  languageUX?: any;

  errorMessage?: Record<string, any>;
  successMessage?: Record<string, any>;
  buttonLoadCheck?: Record<string, any>;
  selectedNurseNote?: any;
};

const toDate = moment();

const CardSelectDoctorOrderNote = (props: CardSelectDoctorOrderNoteProps) => {
  const intl = useIntl();
  // checked
  const [checked, setChecked] = useState<any>([]);
  const [filterDate, setFilterDate] = useState<any>({
    startDate: formatDateToStringBe(toDate),
    endDate: formatDateToStringBe(toDate),
  });

  useEffect(() => {
    props.onEvent({
      message: "HandleNurseNote",
      params: {
        action: "searchDoctorOrderNote",
        card: CARD_SELECT_DOCTOR_ORDER_NOTE,
        startDate: filterDate?.startDate,
        endDate: filterDate?.endDate,
      },
    });
  }, []);

  const handleChecked = (check: boolean | undefined, item: any) => {
    const ids: number[] = item.id_list || [item.id];

    if (checked.some((id: any) => ids.includes(id))) {
      setChecked(checked.filter((id: any) => !ids.includes(id)));
    } else {
      setChecked([...ids]);
    }
  };

  const doctorOrderNote = useMemo(() => {
    return (props.nurseNoteSelectDoctorOrderNote || [])?.map((item: any) => {
      const orderTime = (item?.order_time || "").split(/<br\s*\/?>/);
      const summary = (item?.summary || "").split(/<br\s*\/?>/)?.[0];

      return {
        chk: (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Checkbox
              checked={checked.includes(item.id)}
              onChange={(e, v) => {
                handleChecked(v.checked, item);
              }}
            />
          </div>
        ),
        orderSummaryDetail: (
          <Form style={{ margin: "0px 10px" }}>
            <FormGroup>
              <div style={{ display: "flex" }}>
                <div style={{ color: "#2362b2" }}>วันเวลาที่สั่ง</div>
                <div style={{ margin: "0px 20px" }}>{`${orderTime?.[0] || ""} (${
                  orderTime?.[1] || ""
                })`}</div>
              </div>
            </FormGroup>
            {item?.summary && (
              <FormGroup>
                <div style={{ display: "flex" }}>
                  <div>{summary}</div>
                </div>
              </FormGroup>
            )}
            {item?.plan_item && (
              <FormGroup>
                <div style={{ display: "flex" }}>
                  <div style={{ color: "#2362b2" }}>Planning</div>
                  <div style={{ margin: "0px 20px" }}>{`เริ่มต้น ${
                    item?.plan_item?.start_date || "-"
                  } สิ้นสุด ${item?.plan_item?.end_date || "-"}`}</div>
                </div>
              </FormGroup>
            )}
          </Form>
        ),
      };
    });
  }, [props.nurseNoteSelectDoctorOrderNote, checked]);

  const handleSearchDoctorOrderNote = () => {
    props.onEvent({
      message: "HandleNurseNote",
      params: {
        action: "searchDoctorOrderNote",
        card: CARD_SELECT_DOCTOR_ORDER_NOTE,
        startDate: filterDate?.startDate,
        endDate: filterDate?.endDate,
      },
    });
  };

  const handleSelectDoctorOrderNote = () => {
    const nurseNoteFocus = props.nurseNoteSelectDoctorOrderNote.filter((item: any) =>
      checked.includes(item.id)
    )?.[0];

    const summary = (nurseNoteFocus?.summary || "").split(/<br\s*\/?>/)?.[0];
    const planningText = nurseNoteFocus?.plan_item
      ? `\nPlanning เริ่มต้น ${nurseNoteFocus?.plan_item?.start_date || "-"} สิ้นสุด ${
          nurseNoteFocus?.plan_item?.end_date || "-"
        }`
      : "";

    if (checked.length) {
      props.setProp("selectedNurseNote", {
        ...props.selectedNurseNote,
        doctor_order_detail: `${summary || ""} ${planningText}`,
        doctor_order_id: nurseNoteFocus?.id,
      });
      props.onClose();
    } else {
      props.onClose();
    }
  };

  const handleChangeDate = (type: string) => (date: any) => {
    setFilterDate({
      ...filterDate,
      [`${type}`]: date,
    });
  };

  return (
    <div>
      <CardLayout
        closeable={true}
        toggleable={true}
        titleText="เลือกคำสั่งแพทย์"
        onClose={props.onClose}
      >
        <CardSelectDoctorOrderNoteUX
          intl={intl}
          filterDate={filterDate}
          doctorOrderNote={doctorOrderNote}
          onChangStartDate={handleChangeDate("startDate")}
          onChangEndDate={handleChangeDate("endDate")}
          buttonSearch={
            <ButtonLoadCheck
              // function
              setProp={props.setProp}
              onClick={handleSearchDoctorOrderNote}
              // data
              paramKey={`${CARD_SELECT_DOCTOR_ORDER_NOTE}_search`}
              buttonLoadCheck={props.buttonLoadCheck?.[`${CARD_SELECT_DOCTOR_ORDER_NOTE}_search`]}
              // config
              name="search"
              style={{ width: "100%" }}
              title="ค้นหา"
              color="blue"
            />
          }
          buttonSelect={
            <ButtonLoadCheck
              // function
              setProp={props.setProp}
              onClick={handleSelectDoctorOrderNote}
              // data
              paramKey={`${CARD_SELECT_DOCTOR_ORDER_NOTE}_add_option`}
              buttonLoadCheck={
                props.buttonLoadCheck?.[`${CARD_SELECT_DOCTOR_ORDER_NOTE}_add_option`]
              }
              // config
              name="add_option"
              style={{ width: "100%" }}
              title="เลือก"
              color="green"
            />
          }
        />
      </CardLayout>
    </div>
  );
};

export default CardSelectDoctorOrderNote;
